module.exports = __webpack_public_path__ + "img/girl2.d2cd1565.png";